import React, { useState, useEffect } from 'react'
import { Car, Route, Users, Award } from 'lucide-react'

const CounterAnimation = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    let startTime = null
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime
      const progress = (currentTime - startTime) / duration

      if (progress < 1) {
        setCount(Math.floor(end * progress))
        requestAnimationFrame(animate)
      } else {
        setCount(end)
      }
    }

    requestAnimationFrame(animate)
  }, [end, duration])

  return <>{count.toLocaleString()}+</>
}

const StatBox = ({ icon: Icon, number, text }) => (
  <div className="flex flex-col items-center text-center p-4 md:p-6 bg-gray-800/50 backdrop-blur-sm rounded-lg transform hover:scale-105 transition-transform duration-300">
    <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-gray-800 flex items-center justify-center border-2 border-[#16476e]">
      <Icon className="w-6 h-6 md:w-8 md:h-8 text-white" />
    </div>
    <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2 mt-2">
      <CounterAnimation end={number} />
    </div>
    <div className="text-gray-300 text-xs md:text-sm">{text}</div>
  </div>
)

const Stats = () => {
  const stats = [
    { icon: Car, number: 100, text: 'Vehicles on road' },
    { icon: Route, number: 400, text: 'Trips per day' },
    { icon: Users, number: 1000, text: 'Employee Transits per day' },
    { icon: Award, number: 15, text: 'Years of Experience' },
  ]

  return (
    <div className="relative py-8 md:py-16 min-h-[20rem] md:min-h-[30rem]">
      <div
        className="absolute inset-0 z-0 bg-fixed"
        style={{
          backgroundImage: 'url(images/pexels-life-of-pix-7674.jpg)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className="absolute inset-0 bg-black/40 z-1" />
      {/* Overlay to improve readability */}
      <div className="relative z-10 container mx-auto px-4 md:mt-16" data-aos="slide-up">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {stats.map((stat, index) => (
            <StatBox key={index} {...stat} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Stats
